import React, { useEffect, useState } from 'react';
import GridItem from '../Grid/GridItem';
import { TextField, Chip, Button, Select, MenuItem, Checkbox } from "@mui/material"
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import { MuiColorInput } from 'mui-color-input';
import { APILoggerDetail, buildAPILoggerDetail } from '../../models/APILoggerDetail';
import MiniGraph from './miniGraph'
import CustomNumberInputChanger from '../CustomInput/CustomNumberInputChanger'
import { FormattedMessage, useIntl } from 'react-intl';
interface OverView {
    borderRadius: string
    padding: string
    boxShadow: string
    marginBottom: string
}

interface ModalParagraphStyle {
    margin: string
    color: string
    fontWeight: number
}

interface DisplayUnits {
    name: string
    value: string
}

interface Unit {
    name: string
    value: string
}

interface Props {
    overViewStyle: OverView
    borderColor: string
    modalParagraphStyle: ModalParagraphStyle
    handleGraphSettingsChange: (name: string, value: any, changeGroup: string) => void
    changeGroup: string
    isPressure: boolean
    visible: boolean
    unit: string
    minState: string
    minValue: number
    maxState: string
    maxValue: number
    valueAs: string | null
    axisPosition: string
    lineWidth: number
    graphType: string
    color: string
    labelSize: number
    startDate: Date
    loggers: Array<APILoggerDetail>
    channel: string
    displayUnits: Array<DisplayUnits>
    isTotaliser: boolean
    totalPerDay: boolean
    companyDefault: boolean
    defaultColor: boolean
    pressureUnits: Array<Unit>
    displayAll: boolean | undefined
    allowMinMax: boolean | undefined
    isDigital: boolean | undefined

}

interface NumberInputValues {
    min: number
    max: number
    lineWidth: number
    labelSize: number
}


const GraphSettingsComponent: React.FC<Props> = ({
    overViewStyle,
    borderColor,
    modalParagraphStyle,
    handleGraphSettingsChange,
    changeGroup,
    isPressure,
    visible,
    unit,
    minState,
    minValue,
    maxState,
    maxValue,
    valueAs,
    axisPosition,
    lineWidth,
    graphType,
    color,
    labelSize,
    startDate,
    loggers,
    channel,
    displayUnits,
    isTotaliser,
    totalPerDay,
    companyDefault,
    defaultColor,
    pressureUnits,
    displayAll,
    allowMinMax,
    isDigital


}) => {
    const intl = useIntl()
    const [nonPressureAnalog, setNonPressureAnalog] = useState<boolean>(false)
    const [tempNumberInputValues, setTempNumberInputValues] = useState<NumberInputValues>({min: minValue, max: maxValue, lineWidth: lineWidth, labelSize: labelSize})
    useEffect(() => {
        const testArr = pressureUnits.map(unit => unit.value)
        if (!testArr.includes(unit)) {
            setNonPressureAnalog(true)
        }

    }, [])


    const handleTempNumberChange = (name: string, value: number):void => {
        const tempValues = {...tempNumberInputValues}
        console.log(name, value)
        if (isNaN(value)) {
            value = 0
        }
        if (name === 'MinValue') {
            tempValues.min = value
            tempValues.max = maxValue
            tempValues.labelSize = labelSize
            tempValues.lineWidth = lineWidth

        }
        if (name === 'MaxValue') {
            tempValues.max = value
            tempValues.min = minValue
            tempValues.labelSize = labelSize
            tempValues.lineWidth = lineWidth

        }
        if (name === 'LabelSize') {
            tempValues.min = minValue
            tempValues.max = maxValue 
            tempValues.labelSize = value
            tempValues.lineWidth = lineWidth
        }
        if (name === 'LineWidth') {
            tempValues.min = minValue
            tempValues.max = maxValue 
            tempValues.labelSize = labelSize
            tempValues.lineWidth = value
        }
        console.log(tempValues) 
        setTempNumberInputValues(tempValues)
    }
    useEffect(() => {
        setTimeout(() => {
            handleGraphSettingsChange('MinValue', tempNumberInputValues.min, changeGroup)
            handleGraphSettingsChange('MaxValue', tempNumberInputValues.max, changeGroup)
            handleGraphSettingsChange('LineWidth', tempNumberInputValues.lineWidth, changeGroup)
            handleGraphSettingsChange('LabelSize', tempNumberInputValues.labelSize, changeGroup)
        }, 1000)
        
    }, [tempNumberInputValues])

    console.log(displayAll)

    return (
        <div style={{ display: "flex", borderLeft: `10px solid ${borderColor}`, width: "98.7%", margin: " 20px 300px 0 10px", ...overViewStyle }}>
            <div style={{ minWidth: "100%" }}>
                <GridItem>
                    <div>
                        <h4 style={{ color: "#000000", marginTop: "5px", fontSize: "21px" }}><b>{channel}</b></h4>
                    </div>
                </GridItem>
                <div style={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
                    <div style={{ width: "35%" }}>
                        <GridItem>
                            <h6 style={{ fontSize: "14px", margin: "10px 0", color: "#000000" }}><b><FormattedMessage id="Value settings" /></b></h6>
                            <div style={{ display: "flex", marginBottom: "4px" }}>
                                <p style={modalParagraphStyle}><FormattedMessage id="Visible:" /></p>

                                <Checkbox checked={visible} color="secondary" name={'Visible'} onChange={(e): void => handleGraphSettingsChange(e.target.name, e.target.checked, changeGroup)} />
                            </div>
                            {visible && isTotaliser && <div style={{ display: "flex", marginBottom: "4px" }}>
                                <p style={modalParagraphStyle}><FormattedMessage id="Display As Total for 24 hour period:" /> </p>

                                <Checkbox checked={totalPerDay} color="secondary" name={'PerDay'} onChange={(e): void => handleGraphSettingsChange(e.target.name, e.target.checked, changeGroup)} />
                            </div>}
                            {visible &&  <div style={{ display: "flex" }}>
                                <p style={modalParagraphStyle}><FormattedMessage id="Display Unit:" /></p>
                                {(!nonPressureAnalog || !isPressure) && !isDigital ? <Select
                                    size="small"
                                    style={{ marginLeft: "10px", background: "#ffffff" }}
                                    value={unit}
                                    name={'Unit'}
                                    onChange={(e): void => handleGraphSettingsChange(e.target.name, e.target.value, changeGroup)}
                                >
                                    {displayUnits.map(item => {
                                        return (<MenuItem value={item.value} style={{ zIndex: 111111111111 }} key={item}>{item.name}</MenuItem>)
                                    })}

                                </Select> :
                                    <p style={{color: '#000000', margin: '0 0 0 10px'} }>{unit}</p>
                            }
                            </div>}
                            {visible && <div style={{ display: "flex", alignItems: "center" }}>
                                <p style={modalParagraphStyle}>{`${intl.formatMessage({ id: 'Minimum' })} ${channel} ${intl.formatMessage({ id: 'Axis Value:' })}`}</p>
                                <div style={{ display: 'flex', margin: '7px 0 0 14px', alignItems: 'center' }}>
                                    <FormControlLabel value="default" disabled={isDigital} style={{ color: "#000000" }} control={<Radio color="secondary" />} name={"MinState"} label={intl.formatMessage({ id: "Auto" })} checked={minState === 'default'} onChange={(e): void => handleGraphSettingsChange(e.target.name, e.target.value, changeGroup)} />
                                    <FormControlLabel value="custom" disabled={isDigital} style={{ color: "#000000" }} control={<Radio color="secondary" />} name={"MinState"} label={intl.formatMessage({ id: "Custom" })} checked={minState === 'custom'} onChange={(e): void => handleGraphSettingsChange(e.target.name, e.target.value, changeGroup)} />
                                </div>
                                {minState === 'custom' &&
                                    <div style={{ display: "flex" }}>
                                        <CustomNumberInputChanger disabled={false} value={tempNumberInputValues.min} onChange={handleTempNumberChange} name={'MinValue'}/>
                                        <p style={{ ...modalParagraphStyle, marginLeft: "5px" }}>{unit}</p>
                                    </div>}

                            </div>}

                            {visible && <div style={{ display: "flex", alignItems: "center", marginTop: "-10px" }}>
                                <p style={modalParagraphStyle}>{`${intl.formatMessage({ id: 'Maximum' })} ${channel} ${intl.formatMessage({ id: 'Axis Value:' })}`}</p>
                                <div style={{ display: 'flex', margin: '7px 0 0 10px', alignItems: 'center' }}>
                                    <FormControlLabel value="default" disabled={isDigital} style={{ color: "#000000" }} control={<Radio color="secondary" />} name={"MaxState"} label={intl.formatMessage({ id: "Auto" })} checked={maxState === 'default'} onChange={(e): void => handleGraphSettingsChange(e.target.name, e.target.value, changeGroup)} />
                                    <FormControlLabel value="custom" disabled={isDigital} style={{ color: "#000000" }} control={<Radio color="secondary" />} name={"MaxState"} label={intl.formatMessage({ id: "Custom" })} checked={maxState === 'custom'} onChange={(e): void => handleGraphSettingsChange(e.target.name, e.target.value, changeGroup)} />
                                </div>

                                {maxState === 'custom' &&
                                    <div style={{ display: "flex" }}>
                                        <CustomNumberInputChanger disabled={false} value={tempNumberInputValues.max} onChange={handleTempNumberChange} name={'MaxValue'}/>
                                        <p style={{ ...modalParagraphStyle, marginLeft: "5px" }}>{unit}</p>
                                    </div>}
                            </div>}
                            {isPressure && !nonPressureAnalog && visible && <div style={{ display: "flex", alignItems: "center", marginTop: "-10px" }}>
                                <p style={modalParagraphStyle}><FormattedMessage id="Sample Min/Max" />:</p>
                                <div style={{ display: 'flex', margin: '7px 0 0 10px', alignItems: 'center' }}>
                                    <FormControlLabel value={true} style={{ color: "#000000" }} disabled={!allowMinMax} control={<Radio color="secondary" />} label={intl.formatMessage({ id: "Yes" })} checked={displayAll === true} name={"DisplayAll"} onChange={(e): void => handleGraphSettingsChange(e.target.name, true, changeGroup)} />
                                    <FormControlLabel value={false} style={{ color: "#000000" }} disabled={!allowMinMax} control={<Radio color="secondary" />} label={intl.formatMessage({ id: "No" })} checked={displayAll === false} name={"DisplayAll"} onChange={(e): void => handleGraphSettingsChange(e.target.name, false, changeGroup)} />
                                   
                                </div>
                                {!displayAll && <div style={{display: "flex", marginLeft: "15px"} }>
                                    <p style={modalParagraphStyle}><FormattedMessage id="Value As:" /> </p>
                                    <div style={{ display: 'flex', margin: '7px 0 0 8px', alignItems: 'center' }}>
                                        <Select
                                            name="ValueAs"
                                            onChange={(e): void => handleGraphSettingsChange(e.target.name, e.target.value, changeGroup)}
                                            size="small"
                                            style={{ width: "135px", marginTop: "-7px" }}
                                            value={valueAs}
                                        >
                                            <MenuItem value="min"><FormattedMessage id="Min" /></MenuItem>
                                            <MenuItem value="mean"><FormattedMessage id="Mean" /></MenuItem>
                                            <MenuItem value="max"><FormattedMessage id="Max" /></MenuItem>
                                        </Select>
                                    </div>
                                </div>}
                            </div>}
                        </GridItem>
                    </div>
                    {visible && <div style={{ width: "30%" }} >
                        <GridItem>
                            <h6 style={{ fontSize: "14px", margin: "12px 0", color: "#000000" }}><b><FormattedMessage id="Display settings" /></b></h6>
                            <div style={{ display: "flex", alignItems: "center", marginTop: "-12px" }}>
                                <p style={modalParagraphStyle}><FormattedMessage id="Axis Position:" /> </p>
                                <div style={{ display: 'flex', margin: '7px 0 0 10px', alignItems: 'center' }}>
                                    <FormControlLabel value="left" style={{ color: "#000000" }} control={<Radio color="secondary" />} label={intl.formatMessage({ id: "Left" })} checked={axisPosition === 'left'} name={"AxisPosition"} onChange={(e): void => handleGraphSettingsChange(e.target.name, e.target.value, changeGroup)} />
                                    <FormControlLabel value="right" style={{ color: "#000000" }} control={<Radio color="secondary" />} label={intl.formatMessage({ id: "Right" })} checked={axisPosition === 'right'} name={"AxisPosition"} onChange={(e): void => handleGraphSettingsChange(e.target.name, e.target.value, changeGroup)} />
                                </div>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", marginTop: "-13px" }}>
                                <p style={modalParagraphStyle}><FormattedMessage id="Graph Type:" /></p>
                                {!isDigital ? <div style={{ display: 'flex', margin: '7px 0 0 10px', alignItems: 'center' }}>
                                    <FormControlLabel value="spline" style={{ color: "#000000" }} control={<Radio color="secondary" />} label={intl.formatMessage({ id: "Line" })} checked={graphType === 'spline'} name={"GraphType"} onChange={(e): void => handleGraphSettingsChange(e.target.name, 'spline', changeGroup)} />
                                    <FormControlLabel value="bar" style={{ color: "#000000" }} control={<Radio color="secondary" />} label={intl.formatMessage({ id: "Bar" })} checked={graphType === 'bar'} name={"GraphType"} onChange={(e): void => handleGraphSettingsChange(e.target.name, 'bar', changeGroup)} />
                                </div> : 
                                <p style={{ color: '#000000', margin: '12px 0 10px 10px' }}>Square</p>
                                }
                            </div>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <p style={{ ...modalParagraphStyle, marginRight: "10px" }}><FormattedMessage id="Line/Bar Width:" /></p>
                                <CustomNumberInputChanger disabled={false} value={tempNumberInputValues.lineWidth} onChange={handleTempNumberChange} name={'LineWidth'} />
                                <p style={{ ...modalParagraphStyle, paddingLeft: "7px" }}>px</p>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", margin: "7px 0 7px 0" }}>
                                {companyDefault && <div style={{ display: "flex" }}>
                                    <p style={modalParagraphStyle}><FormattedMessage id="Keep Default Colour Pattern:" /></p>
                                    <Checkbox checked={defaultColor} color="secondary" name={'DefaultColor'} onChange={(e): void => handleGraphSettingsChange(e.target.name, e.target.checked, changeGroup)} />
                                </div>}
                                {!defaultColor && <div style={{ display: "flex" }}>
                                    <p style={modalParagraphStyle}><FormattedMessage id="Colour:" /></p>
                                    <MuiColorInput format="hex" size="small" value={color} name={"Color"} style={{ marginLeft: "10px", background: "#ffffff", width: "150px", zIndex: 100000000 }} onChange={(e): void => handleGraphSettingsChange("Color", e, changeGroup)} />
                                </div>}
                            </div>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <p style={{ ...modalParagraphStyle, marginRight: "10px" }}><FormattedMessage id="Label Font Size:" /> </p>
                                <CustomNumberInputChanger disabled={false} value={tempNumberInputValues.labelSize} onChange={handleTempNumberChange} name={'LabelSize'}/>
                                <p style={{ ...modalParagraphStyle, paddingLeft: "7px" }}>px</p>
                            </div>

                        </GridItem>

                    </div>}
                    {visible && <div style={{ width: "30%", marginRight: "40px" }}>
                        <GridItem>
                            <div>
                                {loggers.length > 0 && <MiniGraph
                                    startDate={startDate}
                                    visible={visible}
                                    channel={channel}
                                    logger={loggers[0].Serial}
                                    unit={unit}
                                    minAxis={minValue}
                                    maxAxis={maxValue}
                                    axisPosition={axisPosition}
                                    graphType={graphType}
                                    lineWidth={lineWidth}
                                    color={color}
                                    labelSize={labelSize}
                                />}
                            </div>
                        </GridItem>
                    </div>}
                </div>

            </div>
        </div>
    )
}
export default GraphSettingsComponent